export default function FooterWave(){
	return (
		<svg id="footer-wave" viewBox="0 0 1000 300" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"
				 color="var(--theme-color1)">
			<path fill="currentColor" opacity="0.15"
				  d="M0 299L-2 19.9998C153 -16.0002 308 155 413 184C515.64 212.35 562 152 645 153C725 154 787 206 874 233C939.54 253.34 975 248 1000 244.61V299H0Z"></path>
			<path fill="currentColor" opacity="0.3"
				  d="M0 300L-2 34C155 -9.00003 300 178 403 212C504.11 245.38 562 165 645 166C725 167 790.09 220.07 874 253C939.21 278.59 978.07 269.72 1000 263.61V300H0Z"></path>
			<path fill="currentColor"
				  d="M0 300L-1 69.7099C216 56.9999 299.47 198.86 403 226C506 253 577 196 660 197C740 198 790.09 234.07 874 267C935.23 291 982 282.61 1000 277.61V300H0Z"></path>
		</svg>
	)
}